import { useQuery } from '@tanstack/react-query';

import { baseAPI } from './base-api';
import { KEYS } from './query-keys';

export interface GHLLocationDetails {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  website?: string;
  // Add other fields as needed
}

export const getGHLLocationDetailsAPI = async (): Promise<GHLLocationDetails> => {
  const response = await baseAPI.get<GHLLocationDetails>('/ghl_auth/location/details');
  return response.data;
};

export const useGetGHLLocationDetails = () =>
  useQuery({
    queryKey: [KEYS.GHL_LOCATION_DETAILS],
    queryFn: getGHLLocationDetailsAPI,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

